import React from "react";
import PropTypes from "prop-types";
import { PackagesNoResultsQuery } from "./StaticQueries/PackagesNoResultsQuery";
import { FlightsNoResultsQuery } from "./StaticQueries/FlightsNoResultsQuery";
import { Section } from "../../../sharedComponents/Section";
// eslint-disable-next-line import/no-cycle
import { CardsContainerGrid } from "../../CardsContainer";
// eslint-disable-next-line import/no-cycle
import { SecondaryCard } from "../../Card";

const NoResultsCards = ({ locale, offerType }) => {
	let data;
	if (offerType === "Package") {
		data = PackagesNoResultsQuery();
	} else {
		data = FlightsNoResultsQuery();
	}

	const localeData = data.find(x => x.node.node_locale === locale);

	return (
		<>
			<Section padding={localeData.node.padding}>
				<CardsContainerGrid cardsPerRow={3}>
					{localeData.node.wrapperSections.pageSections[0].cards.map((card, index) => (
						<SecondaryCard
							// eslint-disable-next-line react/no-array-index-key
							key={`card-${index}`}
							header={card.displayTitle}
							image={{ src: card.cloudinaryImage[0].secure_url }}
							link={{
								to: card.link.url,
								target: card.link.target,
								text: card.link.linkText,
							}}
						/>
					))}
				</CardsContainerGrid>
			</Section>
		</>
	);
};

NoResultsCards.propTypes = {
	locale: PropTypes.string.isRequired,
	offerType: PropTypes.string.isRequired,
};

export default NoResultsCards;
export { NoResultsCards };
